import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export default class Document extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'document',
            id: this.props.Id,
            loading: true,
            lockScreen: 0,
            customers: [],
            data:null,
            record: {
                id: 0,
                customerId: '',
                documentType: '',
                description: '',
                fileBase64: '',
                fileName: ''
            }
        };
    }

    componentDidMount() { this.loadData(); }

    async loadData() {
        const currentId = this.getCurrentFormId();
        this.httpPost(`api/v1/${this.state.controllerName}/get`, { id: currentId })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({ record: data.record, customers: data.customers, loading: false,data:data });
                } else {
                    this.showErorrMessage(data.message);
                    this.setState({ loading: false });
                }
            });
    }

    handleChange(field, value) {
        this.setState({ record: { ...this.state.record, [field]: value } });
    }

    handleFileChange(e) {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64 = reader.result.split(',')[1];
            this.setState({ record: { ...this.state.record, fileBase64: base64, fileName: file.name } });
        };
        reader.readAsDataURL(file);
    }

    async save(e) {
        e.preventDefault();
        this.setState({ lockScreen: 1 });
        this.httpPost(`api/v1/${this.state.controllerName}/save`, this.state.record)
            .then(data => {
                this.setState({ lockScreen: 0 });
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage('مدرک با موفقیت ذخیره شد');
                    this.setState({ redirect: '/documents' });
                } else {
                    this.showErorrMessage(data.message);
                }
            });
    }

    renderForm() {
        const { record, customers } = this.state;
        const isEdit = record.id > 0;
        return (
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">{isEdit ? 'ویرایش مدرک' : 'آپلود مدرک جدید'}</h3>
                        </div>
                        <div className="nk-block-head-content">
                            <NavLink to="/documents/" className="btn btn-dim btn-outline-light"><em className="icon ni ni-arrow-left"></em><span>بازگشت</span></NavLink>
                        </div>
                    </div>
                </div>
                <form onSubmit={e => this.save(e)}>
                    <div className="nk-block">
                        <div className="card card-bordered">
                            <div className="card-inner">
                                <div className="row g-4">
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label className="form-label">مشتری <span className="text-danger">*</span></label>
                                            <select className="form-select" value={record.customerId} onChange={e => this.handleChange('customerId', e.target.value)}>
                                                <option value="">-- انتخاب مشتری --</option>
                                                {customers.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label className="form-label">نوع مدرک</label>
                                            <input type="text" className="form-control" value={record.documentType} onChange={e => this.handleChange('documentType', e.target.value)} placeholder="مثلاً فاکتور، قرارداد" />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label className="form-label">توضیح</label>
                                            <textarea className="form-control" rows="3" value={record.description} onChange={e => this.handleChange('description', e.target.value)}></textarea>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label className="form-label">فایل اسکن</label>
                                            <input type="file" className="form-control" onChange={e => this.handleFileChange(e)} />
                                            {record.fileName && <small className="text-muted">{record.fileName}</small>}
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <button type="submit" className="btn btn-primary" disabled={this.state.lockScreen === 1}>
                                            {this.state.lockScreen === 1 && <span className="spinner-border spinner-border-sm mr-2"></span>}
                                            <em className="icon ni ni-save"></em> ذخیره
                                        </button>
                                        <NavLink to="/documents/" className="btn btn-dim btn-outline-light ms-2"><em className="icon ni ni-cross"></em> انصراف</NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />;
        let contents = this.state.loading ? this.renderLoading() : [
            this.state.lockScreen === 1 && this.lockScreen(),
            <Header data={{ global: this.state.data?.global }} />,
            <div className="nk-content "><div className="container-fluid"><div className="nk-content-inner">{this.renderForm()}</div></div></div>,
            <Footer />
        ];
        return contents;
    }
}